import { PluginStore } from "graylog-web-plugin/plugin";
import View from "views/logic/views/View";
import UpdateSearchForWidgets from "views/logic/views/UpdateSearchForWidgets";
const CopyPageToDashboard = (queryId, sourceDashboard, targetDashboard) => {
  if (targetDashboard.type !== View.Type.Dashboard) {
    return void 0;
  }
  const copyHooks = PluginStore.exports("views.hooks.copyWidgetToDashboard");
  const selectedViewState = sourceDashboard.state.get(queryId);
  const selectedQuery = sourceDashboard.search.queries.find((query) => query.id === queryId);
  const newQuery = selectedQuery.toBuilder().newId().build();
  const newState = targetDashboard.state.set(newQuery.id, selectedViewState.duplicate());
  const newQueries = targetDashboard.search.queries.add(newQuery);
  const newSearch = targetDashboard.search.toBuilder().queries(newQueries).build();
  const updatedDashboard = UpdateSearchForWidgets(
    targetDashboard.toBuilder().state(newState).search(newSearch).build()
  );
  return copyHooks.reduce(
    (previousDashboard, copyHook) => copyHook(sourceDashboard, previousDashboard),
    updatedDashboard
  );
};
export default CopyPageToDashboard;
